import Base from 'app/collections/base';
import { appUrl } from 'utils/wrappers';
import ApiKey from 'app/models/api_key';

export default Base.extend({
  model: ApiKey,
  key: 'keys',
  url: appUrl('api_keys'),

  comparator: 'created_at',
});



// WEBPACK FOOTER //
// ./app/collections/api_keys.js